$(function(){
  $('.collapse').on('show.bs.collapse',function(){
    $(this).closest('.panel').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up');
    $(this).closest('.panel').find('.panel-title').addClass('panel-title_clr-open');
  });
  $('.collapse').on('hide.bs.collapse',function(){
    $(this).closest('.panel').find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down');
    $(this).closest('.panel').find('.panel-title').removeClass('panel-title_clr-open');
  });
});